'use client';

import React__default from 'react';
import { t } from '../../Utils/helpers.js';

var PlayIcon = function (_a) {
    var language = _a.language;
    return (React__default.createElement("svg", { role: 'img', height: '24', width: '24', "aria-hidden": 'false', className: 'Svg-sc-ytk21e-0 gQUQL ydKMFPgNHlpYPxfI_zRw', viewBox: '0 0 24 24', "data-encore-id": 'icon', fill: '#fff' },
        React__default.createElement("title", null, t('Play', language)),
        React__default.createElement("path", { d: 'M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12zm8.75-4.567a.5.5 0 0 0-.75.433v8.268a.5.5 0 0 0 .75.433l7.161-4.134a.5.5 0 0 0 0-.866L9.75 7.433z' })));
};

export { PlayIcon as default };
//# sourceMappingURL=index.js.map
